module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-15.d8cda861.png";